import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Keyframes"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "css-keyframes"
    }}>{`CSS Keyframes`}</h1>
    <p>{`Using keyframes with Theme UI is fully supported, but not part of the Theme UI
library itself. Instead, use `}<a parentName="p" {...{
        "href": "https://emotion.sh/docs/keyframes"
      }}>{`the `}<inlineCode parentName="a">{`keyframes`}</inlineCode>{` helper from Emotion`}</a>{`.`}</p>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <ol>
      <li parentName="ol"><inlineCode parentName="li">{`import { keyframes } from '@emotion/react'`}</inlineCode></li>
      <li parentName="ol">{`Create a variable using `}<inlineCode parentName="li">{`keyframes`}</inlineCode>{` for your animation (examples below)`}</li>
      <li parentName="ol">{`Use the variable as the animation name, in an `}<inlineCode parentName="li">{`animation`}</inlineCode>{` or `}<inlineCode parentName="li">{`animationName`}</inlineCode>{`
declaration`}</li>
    </ol>
    <Note mdxType="Note">
      <p><inlineCode parentName="p">{`@emotion/react`}</inlineCode>{` is a peer dependency of Theme UI, so while required alongside Theme UI packages,
it needs manual installation in your project.`}</p>
    </Note>
    <h2 {...{
      "id": "examples"
    }}>{`Examples`}</h2>
    <p>{`Using object syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { Box } from 'theme-ui'
import { keyframes } from '@emotion/react'

const fadeIn = keyframes({ from: { opacity: 0 }, to: { opacity: 1 } })

export default (props) => (
  <Box
    {...props}
    sx={{ animation: \`\${fadeIn} 1s backwards\` }}
  />
)
`}</code></pre>
    <Note mdxType="Note">
      <p>{`To directly set `}<inlineCode parentName="p">{`animationName`}</inlineCode>{` using object syntax, append `}<inlineCode parentName="p">{`.toString()`}</inlineCode>{` to the animation variable.
This workaround is not needed when using the variable inside a template string, such as above.`}</p>
    </Note>
    <p>{`Using template literal syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`/** @jsx jsx */
import { jsx } from 'theme-ui'
import { keyframes } from '@emotion/react'

const wave = keyframes\`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-5deg);
  }
\`

export default (props) => (
  <div
    {...props}
    sx={{ animation: \`\${wave} 0.5s linear infinite alternate\` }}
  />
)
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      